import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InfoField, InfoFieldItem } from '../../../../../components/shared/info-field/info-field';
import { Slider } from '../../../../../components/slider/slider';
import { TrackClickDirective } from '../../../../../directives/track-click.directive';
import { ReguaSegment } from '../../../../../interfaces/quick-approval.interface';
import { FormatterHelperService } from '../../../../../services/helpers/formatter-helper.service';

@Component({
  selector: 'app-lead-details-pr',
  standalone: true,
  imports: [InfoField, Slider, TrackClickDirective],
  templateUrl: './leads-details-pr.html',
  styleUrls: ['../shared/lead-detail-shared.scss', './leads-details-pr.scss'],
})
export class LeadsDetailsPr {
  leadInfo: Record<string, InfoFieldItem[]> = {};
  financingInfo: Record<string, InfoFieldItem[]> = {};
  @Input() set details(value: any) {
    if (value) {
      this.mapDetails(value);
    }
  }
  @Input() showQuickApproval = false;
  @Input() sliderLoading = false;
  @Input() sliderValue = 0;
  @Input() reguaSegments: ReguaSegment[] = [];
  @Output() sliderValueChange = new EventEmitter<number>();
  @Output() navigate = new EventEmitter<number>();
  @Output() generateSimulation = new EventEmitter<void>();

  constructor(private readonly formatter: FormatterHelperService) {}

  private mapDetails(details: any): void {
    this.leadInfo = {
      linha1: [
        {
          type: 'image',
          imageUrl: details.renovaMais ? 'assets/images/renewalBlue.png' : 'assets/images/renewalGray.png',
          imageAlt: details.renovaMais ? 'Renova Mais Ativo' : 'Renova Mais Inativo',
        },
        { type: 'text', title: 'Nome', info: details.nome || '-' },
        { type: 'text', title: 'CPF', info: this.formatter.CPF(details.cpf) },
        { type: 'text', title: 'Data Nasc.', info: this.formatter.data(details.dataNascimento) },
        { type: 'text', title: 'Tipo Pessoa', info: details.tipoPessoa || '-' },
        { type: 'text', title: 'Data de Criação', info: this.formatter.data(details.dataCriacao) },
        { type: 'text', title: 'DN', info: details.dn ? `${details.dn.toString().padStart(4, '0')}` : '-' },
        { type: 'text', title: 'Preferência de Contato', info: details.preferenciaContato || '-' },
      ],
      linha2: [
        { type: 'status', title: 'Status', info: details.statusDoLead || '-', leadId: details.idLead },
        { type: 'text', title: 'Celular', info: this.formatter.celular(details.celular) },
        { type: 'text', title: 'Tel. Residencial', info: this.formatter.telefone(details.telefoneResidencial) },
        { type: 'text', title: 'Tel. Comercial', info: this.formatter.telefone(details.telefoneComercial) },
        { type: 'text', title: 'Tel. Adicional', info: this.formatter.telefone(details.telefoneAdicional) },
        { type: 'text', title: 'Email', info: details.email || '-' },
      ],
      linha3: [
        { type: 'text', title: 'CEP', info: this.formatter.CEP(details.cep) },
        { type: 'text', title: 'Estado', info: details.estado || '-' },
        { type: 'text', title: 'Cidade', info: details.cidade || '-' },
      ],
    };

    this.financingInfo = {
      linha1: [
        { type: 'text', title: 'Número do Contrato', info: details.codigoContrato || '-' },
        { type: 'text', title: 'Data Inicio', info: this.formatter.data(details.dataInicioContrato) },
        { type: 'text', title: 'Data fim do contrato', info: this.formatter.data(details.dataFimContrato) },
        { type: 'text', title: 'Data de Liquidação', info: this.formatter.data(details.dataLiquidacaoContrato) },
        { type: 'text', title: 'Status contrato', info: details.statusDoContrato || '-' },
        { type: 'text', title: 'Disponível desde', info: this.formatter.data(details.disponivelDesde) },
        { type: 'text', title: 'Descrição do Plano', info: details.plano || '-' },
        { type: 'text', title: 'Tipo de Uso', info: details.tipoUso || '-' },
      ],
      linha2: [
        { type: 'text', title: 'Marca', info: details.marca || '-' },
        { type: 'text', title: 'Modelo', info: details.modeloGrupo || '-' },
        { type: 'text', title: 'Modelo Completo', info: details.modeloCompleto || '-' },
        { type: 'text', title: 'Versão', info: details.versao || '-' },
        { type: 'text', title: 'Ano de Fabricação', info: details.anoFabricacao?.toString() || '-' },
        { type: 'text', title: 'Ano Modelo', info: details.anoModelo?.toString() || '-' },
        { type: 'text', title: 'Chassi', info: details.chassi || '-' },
      ],
      linha3: [
        { type: 'text', title: 'Valor do veículo', info: this.formatter.moeda(details.valorVeiculo) },
        { type: 'text', title: 'Valor Financiado', info: this.formatter.moeda(details.valorFinanciado) },
        { type: 'text', title: 'Valor de Entrada', info: this.formatter.moeda(details.valorEntrada) },
        { type: 'text', title: 'Valor da parcela', info: this.formatter.moeda(details.valorParcela) },
        { type: 'text', title: 'Parcela Residual', info: this.formatter.moeda(details.valorParcelaResidual) },
      ],
    };
  }
}
